import { useSelector } from 'react-redux';
import { getIsInAppBrowser } from '../store/system';

export function useSystem() {
  // TODO maybe change to Platform
  const isInAppBrowser = useSelector(getIsInAppBrowser);

  return {
    isInAppBrowser,
  };
}
